import React, { Component } from 'react';
import 'assets/css/geral.css';
import IconButton from '@material-ui/core/IconButton';
import Print from '@material-ui/icons/Print';
import { dominioDemandaCirurgica } from '../../config/database';

class itensEventuais extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  impressoMateriaisEventuais = async () => {
    await dominioDemandaCirurgica().then(promise => {
      window.open(`${promise.config.baseURL}/impressoMateriaisEventuais/${this.props.pedido.id}`);
    });
  };

  renderBotao = () => {
    return (
      <IconButton onClick={this.impressoMateriaisEventuais} style={{ backgroundColor: '#ce4958' }}>
        <Print style={{ color: '#ffffff' }} />
      </IconButton>
    );
  };

  render() {
    return <>{this.renderBotao()}</>;
  }
}

export default itensEventuais;
